import { render } from "./Tracker.vue?vue&type=template&id=ad889884&scoped=true"
import script from "./Tracker.vue?vue&type=script&lang=js"
export * from "./Tracker.vue?vue&type=script&lang=js"

import "./Tracker.vue?vue&type=style&index=0&id=ad889884&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/shamudeen/shamudeen/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad889884"]])

export default __exports__